// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recording {
  width: 100%;
  height: 100%;
}
.recording .editor {
  z-index: 0;
}
.recording__canvas {
  max-width: 100%;
  max-height: 100%;
}
.recording__size {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
}
.recording__render {
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/recording/Recording.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;AACD;AACC;EACC,UAAA;AACF;AAEC;EACC,eAAA;EACA,gBAAA;AAAF;AAGC;EACC,eAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;AADF;AAIC;EACC,eAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;AAFF","sourcesContent":[".recording {\n\twidth: 100%;\n\theight: 100%;\n\n\t.editor {\n\t\tz-index: 0;\n\t}\n\n\t&__canvas {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t}\n\n\t&__size {\n\t\tposition: fixed;\n\t\tz-index: 1;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t&__render {\n\t\tposition: fixed;\n\t\tz-index: 1;\n\t\ttop: 0;\n\t\tright: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
